import { getDateNoTime } from '@assets/js/dateUtils';

export const tableProperties = [
  { label: '客户货号', prop: 'prod_cust_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '客户简称', prop: 'transaction_customer_name', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '我司货号', prop: 'prod_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '更改号', prop: 'change_no', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '业务部门', prop: 'sales_department_name', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '外销员', prop: 'sales_staff_name', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  {
    label: '打样单号',
    prop: 'sampling_order_number',
    itemType: 'input',
    input: true,
    sortable: false,
    labelWidth: 120,
    subItem: { type: 'input', required: true, disabled: true }
  },
  { label: '品名', prop: 'prod_name', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '单位', prop: 'prod_unit', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  {
    label: '通知时间',
    prop: 'create_time',
    itemType: 'date',
    input: false,
    sortable: false,
    labelWidth: 120,
    formatter: val => getDateNoTime(val, true)
  },
  { label: '状态', prop: 'status', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '操作', prop: 'operation', itemType: 'input', input: false, sortable: false, labelWidth: 120 }
];
